import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=d8cc3eda&scoped=true&"
import script from "./Entity.vue?vue&type=script&lang=js&"
export * from "./Entity.vue?vue&type=script&lang=js&"
import style0 from "./Entity.vue?vue&type=style&index=0&id=d8cc3eda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cc3eda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8cc3eda')) {
      api.createRecord('d8cc3eda', component.options)
    } else {
      api.reload('d8cc3eda', component.options)
    }
    module.hot.accept("./Entity.vue?vue&type=template&id=d8cc3eda&scoped=true&", function () {
      api.rerender('d8cc3eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Entity.vue"
export default component.exports